import { Container } from "pixi.js";
import { ICanvasScaler } from "../../../../../canvas/ICanvasScaler";
import { PromiseCompletionSource } from "../../../../../shared/async/PromiseCompletionSource";
import { BaseScalableView } from "../../../common/BaseScalableView";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { SoundsResourcePackageWrapper } from "../../../common/resources/SoundsResourcePackageWrapper";
import { TopPanel } from "../../../game/components/toppanel/TopPanel";
import { IStealController } from "../controllers/IStealController";
import { StealResourcePackage } from "../resources/StealResourcePackage";
import { MainStealPage } from "./pages/MainStealPage";
import { StealSummaryPage } from "./pages/StealSummaryPage";
import { UserProfileResourcePackage } from "../../userprofile/resources/UserProfileResourcePackage";
import { StealCard } from "../../../game/flow/impl/diceActions/stealAction/StealCard";

export class StealPopupView extends BaseScalableView<void> {
    private readonly stealResources: StealResourcePackage;
    private readonly commonResources: CommonResourcesPackage;
    private readonly soundResources: SoundsResourcePackageWrapper;
    private readonly userProfileResources: UserProfileResourcePackage;
    private readonly stealController: IStealController;
    private readonly topPanel: TopPanel;

    public constructor(
        operationControls: PromiseCompletionSource<void>,
        stealResources: StealResourcePackage,
        commonResources: CommonResourcesPackage,
        soundResources: SoundsResourcePackageWrapper,
        userProfileResources: UserProfileResourcePackage,
        canvasScaler: ICanvasScaler,
        stealController: IStealController,
        topPanel: TopPanel
    ) {
        super(operationControls, canvasScaler);
        this.stealResources = stealResources;
        this.commonResources = commonResources;
        this.soundResources = soundResources;
        this.userProfileResources = userProfileResources;
        this.stealController = stealController;
        this.topPanel = topPanel;
        this.build();
    }

    public async start(): Promise<void> {
    }

    private async build(): Promise<void> {
        const pagesContainer = new Container();
        this.addChild(pagesContainer);
        const mainStealPageCS = new PromiseCompletionSource<StealCard>();
        const mainStealPage = new MainStealPage(
            this.canvasScaler,
            this.stealResources,
            this.commonResources,
            this.soundResources,
            this.userProfileResources,
            this.stealController,
            this.topPanel,
            mainStealPageCS
        );
        pagesContainer.addChild(mainStealPage);
        await mainStealPageCS.result;
        pagesContainer.removeChild(mainStealPage);
        this.operationControls.complete();
    }
}
